import { gql } from '@apollo/client';
import { BASIC_INFORMATION_FRAGMENT } from './query';

export const ANSWER_BASIC_INFOS = gql`
  mutation answerBasicInfos($input: AnswerBasicInfosInput!) {
    answerBasicInfos(input: $input) {
      questions {
        id
        status
      }
      profile {
        id
        ...BasicInformation
      }
    }
  }
  ${BASIC_INFORMATION_FRAGMENT}
`;
